import React from "react";
import "./organicFarming.css";
import bannerImage from "../../assets/organic-farming-main.JPG"; // Replace with your banner image
import contentImage from "../../assets/org.jpg"; // Replace with your content image

const OrganicFarming = () => {
  return (
    <div className="organic-farming-section">
      {/* Banner Section */}
      <div className="banner">
        <img src={bannerImage} alt="Organic Farming Banner" className="organic-banner"/>
        <h1>Organic Farming</h1>
      </div>

      {/* Introduction Section */}
      <div className="intro">
        <p>
          The area embraces organic farming with a focus on producing high-quality grains rather than maximizing yield. Crops like Sorghum (<i>ज्वारी</i>), Bajra (<i>बाजरी</i>), Barnyard Millet (<i>भडली नाचणी</i>), Maize (<i>मका</i>), Pigeon pea (<i>तूर</i>), Moong (<i>मुग</i>), Udid (<i>उडीद</i>), Cow Pea (<i>चवळी</i>), Gram (<i>हरभरा</i>), and various others are cultivated using natural inputs such as Dasparni extract, Jeevamrit, Nimboli Ark, cow urine, cow dung, and vermicompost. Additionally, a variety of vegetables are grown, with the institution’s cow dung serving as an essential resource for soil enrichment.
        </p>

        <p>
          Natural farming is also practiced in some sections, where fruit trees, wild vegetables, and vines grow without any human intervention or chemical inputs. The area is home to fruit trees such as Custard apple, Guava, Tamarind, Indian Jujube, Moringa, and Amla. This chemical-free approach not only supports healthy crop production but also improves soil texture and fertility over time.
        </p>
      </div>

      {/* Content Image Section */}
      <div className="content-image">
        <img src={contentImage} alt="Organic Farming Practices" />
      </div>

      {/* Sustainable Farming Section */}
      <div className="sustainable-farming">
        <h2>Sustainable Farming Practices</h2>
        <p>
          To ensure sustainable farming practices, wells have been dug for protected irrigation, and various water conservation measures, including treatments to prevent runoff, have been implemented. <i>Shramdan</i> (voluntary labor) plays a critical role in these efforts, enabling large-scale water conservation work that strengthens the area's water sources. As a result, millions of liters of water, which would otherwise be lost, are retained annually, securing a sustainable water supply for agriculture and other needs.
        </p>
        <p>
          Grain produced on the farm is sufficient to feed laborers throughout the year. Produce is also used in various activities, such as the Wild Vegetable Festival, emphasizing a self-sustaining ecosystem.
        </p>
      </div>

      {/* Fresh Produce Section */}
      <div className="fresh-produce">
        <h2>Fresh Organic Produce for Sale! 🌱</h2>
        <ul>
          <li>Green gram<i>(मूंग डाळ)</i></li>
          <li>Pigeon pea<i>(तूर डाळ)</i></li>
          <li>Barnyard Millet<i>(भादळी)</i></li>
          <li>Black gram <i>(उडद डाळ)</i></li>
        </ul>
        <p>Enjoy 100% chemical-free, farm-fresh fruits, veggies, and more.</p>
        <p>
          <strong>Order Now:</strong> Contact us for healthy, delicious, and natural goodness.
        </p>
      </div>
    </div>
  );
};

export default OrganicFarming;
